import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, Table, DLMenu, YouTubeCoverImage } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditReviewModal from '../../Modals/Review/EditReviewModal';
import { parseYouTubeUrl } from 'appSrc/utils';
import style from './styles/style.module.css';

class SortableReviewsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            reviewInEdit: null,
            reviewInEditIndex: -1,
        };
    }
    openEditModal = ( index, review ) => {
        this.setState( { reviewInEdit: review, reviewInEditIndex: index } );
    }
    onEditSubmit = ( updatedReview ) => {
        var index = this.state.reviewInEditIndex;
        this.props.onReviewUpdated( index, updatedReview );
        this.setState( { reviewInEdit: null, reviewInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { reviewInEdit: null, reviewInEditIndex: -1 } );
    }

    render() {
        const { reviews } = this.props;

        return (
            <div>
                <Table
                className={ style.reviewsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell className={ style.coverImage }></Table.Cell>
                            <Table.Cell>REVIEW TITLE</Table.Cell>
                            <Table.Cell>TEXT</Table.Cell>
                            <Table.Cell className={ style.actionsCell }>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( reviews ) }
                    </Table.SortableBody>
                </Table>
                { this.state.reviewInEdit &&
                    <EditReviewModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    review={ this.state.reviewInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( reviews ) => {
        var rows = reviews.map( ( review, index ) => {
            var youtubeId = review.video_url ? parseYouTubeUrl( review.video_url ) : false;
            let imageEl = null;
            if( review.image ) {
                imageEl = ( <img src={ review.image } /> );
            } else if( youtubeId ) {
                imageEl = ( <YouTubeCoverImage videoId={ youtubeId } key={ youtubeId } /> );
            }

            return (
                <Table.Row key={ review.id }>
                    <Table.Cell className={ style.coverImage }>
                        <div className={ style.coverImage }>
                            { imageEl }
                        </div>
                    </Table.Cell>
                    <Table.Cell>
                        { review.title }
                    </Table.Cell>
                    <Table.Cell>
                        <TextTruncate
                        line={ 2 }
                        text={ review.review_text } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, review );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
SortableReviewsTable.defaultProps = {
    onReviewUpdated: ()=>{},
};

export default connect()( SortableReviewsTable );
